import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { sleep } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-await-notification-modal',
	templateUrl: './await-notification-modal.component.html',
	styleUrls: ['./await-notification-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AwaitNotificationModalComponent implements OnInit {
	// 🔧 Circle's settings
	size = 140; // size of SVG
	stroke = 8; // border width
	radius = 60;
	duration = 30; // in sec

	title = '';
	message = '';
	autoDismiss = false;

	// 🧮 Automatic values
	center = this.size / 2;
	circumference = 2 * Math.PI * this.radius;
	time = this.duration;
	progress = 100;
	private startTime!: number;
	private reqId!: number;

	getDashOffset() {
		return this.circumference - (this.circumference * this.progress) / 100;
	}

	private modalCtrl = inject(ModalController);
	private cdr = inject(ChangeDetectorRef);

	constructor() {}
	ngOnInit(): void {
		this.animate();
	}

	animate(timestamp?: number) {
		if (!this.startTime) {
			this.startTime = timestamp ?? performance.now();
		}
		const now = timestamp ?? performance.now();
		const elapsed = (now - this.startTime) / 1000; // в секундах

		const remaining = Math.max(this.duration - elapsed, 0);

		this.time = Math.ceil(remaining);

		this.progress = (remaining / this.duration) * 100;

		this.cdr.detectChanges();

		if (remaining > 0) {
			this.reqId = requestAnimationFrame(t => this.animate(t));
		} else {
			cancelAnimationFrame(this.reqId);
			this.modalCtrl.dismiss();
		}
	}

	static async show(
		modalCtrl: ModalController,
		title: string,
		message: string,
		duration: number = 5
	): Promise<boolean> {
		const modal = await modalCtrl.create({
			cssClass: 'auto-height item-modal',
			component: AwaitNotificationModalComponent,
			componentProps: {
				title,
				message,
				duration,
			},
			showBackdrop: true,
			backdropDismiss: false,
		});

		await modal.present();

		const result = await modal.onDidDismiss();
		await sleep(100);
		return result.data;
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
